import React, { useState } from 'react';
import cx from 'classnames';
import { CircularProgress, MenuItem } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Modal from '../../../../components/Modal';
import { useAppDispatch, useAppSelector, useFetchIntegrations } from '../../../../hooks/redux';
import Button from '../../../../components/Button';
import Menu from '../../../../components/Menu';
import ModalMark from '../ModalMark';
import { TState } from '../../types';
import { ReactComponent as CancelIcon } from '../../images/cancel.svg';
import { ReactComponent as EditlIcon } from '../../images/edit.svg';
import { EBankStatus } from '../../../../store/reducers/enumTypes';
import { intregrationSlice, deleteIntegration } from '../../../../store/reducers/integrationSlice';

import css from './Integrations.module.scss';

type TIntegrations = {
  setState: React.Dispatch<React.SetStateAction<TState>>;
};

export const Integrations = ({ setState }: TIntegrations) => {
  useFetchIntegrations();

  const dispatch = useAppDispatch();
  const [isOpen, setOpen] = useState<boolean>(false);
  const [paramsId, setParamIds] = useState<string>('');
  const { setEditIntegrationId } = intregrationSlice.actions;
  const { intregrations, loading } = useAppSelector((state) => state.integrationReducer);
  const editIntegration = (paramsId: string) => {
    dispatch(setEditIntegrationId(paramsId));
    setState(TState.EDIT);
  };
  const removeIntegration = (paramsId: string) => {
    dispatch(deleteIntegration({ paramsId }));
    setOpen(false);
  };
  const editCutOffTime = (paramsId: string) => {
    dispatch(setEditIntegrationId(paramsId));
    setState(TState.CUT_OFF_TIME);
  };

  if (loading) {
    return <CircularProgress />;
  }

  return (
    <section className={css.root}>
      <Button onClick={() => setState(TState.ADD)}>+ Add new</Button>
      <div className={css.table}>
        <div className={css.head}>
          <div className={css.col1}>Channel</div>
          <div className={css.col2}>Status</div>
        </div>
        <ul className={css.body}>
          {intregrations?.map((item, index) => (
            <li key={`intregration_${index}`} className={css.item}>
              <div className={css.col1}>{item.name}</div>
              <div
                className={cx(
                  css.col2,
                  item.status === EBankStatus.ENABLED ? css.isEnabled : css.isDisabled
                )}
              >
                {item.status.toUpperCase()}
              </div>
              <div className={css.buttons}>
                <Menu>
                  <MenuItem disableRipple onClick={() => editIntegration(item.paramsId)}>
                    <EditlIcon className={css.icon} />
                    Edit
                  </MenuItem>
                  <MenuItem
                    disableRipple
                    onClick={() => {
                      setOpen(true);
                      setParamIds(item.paramsId);
                    }}
                  >
                    <CancelIcon className={css.icon} />
                    Cancel
                  </MenuItem>
                  <MenuItem disableRipple onClick={() => editCutOffTime(item.paramsId)}>
                    <AccessTimeIcon className={cx(css.icon, css.time)} />
                    Change Cut-off Time
                  </MenuItem>
                </Menu>
              </div>
            </li>
          ))}
        </ul>
      </div>
      <Modal isOpen={isOpen} handleClose={() => setOpen(false)}>
        <ModalMark />
        <div className={css.title}>Are you sure you want to cancel the connectivity?</div>
        <div className={css.description}>
          If you cancel now, your progress and history of transactions will be lost.
        </div>
        <div className={css.buttons}>
          <Button width="140px" size="medium" variant="outlined" onClick={() => setOpen(false)}>
            Stay in this page
          </Button>
          <Button
            width="124px"
            size="medium"
            onClick={() => removeIntegration(paramsId)}
            color="error"
          >
            Yes, cancel
          </Button>
        </div>
      </Modal>
    </section>
  );
};
